import { __assign } from "tslib";
// DS: C17
import React, { useContext } from 'react';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import SiteHeaderDesktop from './SiteHeaderDesktop';
import SiteHeaderMobile from './SiteHeaderMobile';
var SiteHeader = function (props) {
    var isMobile = useContext(MobileContext);
    return (React.createElement(React.Fragment, null, isMobile ? (React.createElement(SiteHeaderMobile, __assign({}, props))) : (React.createElement(SiteHeaderDesktop, __assign({}, props)))));
};
SiteHeader.displayName = 'SiteHeader';
export default SiteHeader;
//# sourceMappingURL=SiteHeader.js.map